

// 正式

const VUE_APP_WS_URL = 'wss://api.cfdcc.com/websocket';
const VUE_APP_BASEURL = 'https://api.cfdcc.com';
// 测试
// const VUE_APP_WS_URL = 'ws://192.168.1.2:8080/websocket';//测试
//const VUE_APP_BASEURL = 'http://127.0.0.1:8080';//测试

export { VUE_APP_WS_URL, VUE_APP_BASEURL };
